import { assessmentConstants as constants } from '../constants';
import { assessmentServices as services } from '../services';

export const assessmentActions = {
    updatePage,
    getPage
};

function updatePage(page, answers) {
    return dispatch => {
        dispatch(request(true));

        services.save(answers, page)
            .then(
                (data) => {                    
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: constants.PAGE_REQUEST } }
    function success(data) { return { type: constants.PAGE_SUCCESS, data } }
    function failure(error) { return { type: constants.PAGE_FAILURE, error } }
}

function getPage(page) {
    return dispatch => {
        dispatch(request(true));

        services.getPage(page)
            .then(
                (data) => {
                    dispatch(success(data));
                },
                error => {
                    dispatch(failure(error));
                }
            );
    };

    function request() { return { type: constants.PAGE_REQUEST } }
    function success(data) { return { type: constants.PAGE_SUCCESS, data } }
    function failure(error) { return { type: constants.PAGE_FAILURE, error } }
}